import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { IGlobalStoreReducers } from './initStore';

export interface IStampDialogState {
    visible: boolean;
}

export const stampDialogSlice = createSlice({
    name: 'stampDialog',
    initialState: { visible: false } as IStampDialogState,
    reducers: {
        update: (state, action: PayloadAction<boolean>) => {
            state.visible = action.payload;
        },
    },
});

export const { update } = stampDialogSlice.actions;
export const stampDialogVisibility = (state: IGlobalStoreReducers) => state.stampDialog.visible;

export default stampDialogSlice.reducer;
